<template>
  <div>
    <el-carousel
      class="land-home-carousel"
      indicator-position="none"
      :arrow="isHover"
      ref="cardShow"
    >
      <el-carousel-item
        v-for="(item,index) in bannerList"
        :key="index" @click.native="clickBanner(item.bannerName)"
      >
        <a :href="item.link" target="_blank" v-if="item.link"><img
            :src="item.bannerUrl"
            height="100%"
          /> </a>
          <img :src="item.bannerUrl" height="100%" v-else>
      </el-carousel-item>
    </el-carousel>
    <el-row
      :gutter="12"
      type="flex"
      justify="space-between"
      class="land-home-location"
    >
      <el-col
        :span="8"
        :class="{'animate__animated animate__pulse':flag1}"
        @mouseover.native="flag1=true"
        @mouseleave.native="flag1=false"
      >
        <el-card shadow="hover">
          <el-row type="flex" justify="center" style="width:326px">
            <el-col
              :span="12"
              style="width:65px"
            ><img :src="accurateUrl" /></el-col>
            <el-col :span="12" style="width:auto">
              <el-row class="home-location-title">目标估(定)得准</el-row>
              <!-- <el-row class="home-location-text">业务数据一体化，专业经验组织化</el-row> -->
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col
        :span="8"
        :class="{'animate__animated animate__pulse':flag2}"
        @mouseover.native="flag2=true"
        @mouseleave.native="flag2=false"
      >
        <el-card shadow="hover">
          <el-row type="flex" justify="center" style="width:326px">
            <el-col
              :span="12"
              style="width:72px"
            ><img :src="controlUrl" /></el-col>
            <el-col :span="12" style="width:auto">
              <el-row class="home-location-title">过程控得住</el-row>
              <!-- <el-row class="home-location-text">经营分析可视化，成本管控智能化</el-row> -->
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col
        :span="8"
        :class="{'animate__animated animate__pulse':flag3}"
        @mouseover.native="flag3=true"
        @mouseleave.native="flag3=false"
      >
        <el-card shadow="hover">
          <el-row type="flex" justify="center" style="width:326px">
            <el-col
              :span="12"
              style="width:72px"
            ><img :src="wasteUrl" /></el-col>
            <el-col :span="12" style="width:auto">
              <el-row class="home-location-title">成本0浪费</el-row>
              <!-- <el-row class="home-location-text">数据积累无感化，价格更新动态化</el-row> -->
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import 'animate.css'
import { getBannerList } from '@/api/landing'
const accurateUrl = require('@/assets/images/svg/accurate.svg')
const controlUrl = require('@/assets/images/svg/control.svg')
const wasteUrl = require('@/assets/images/svg/waste.svg')
export default {
  name: 'landHomeBanner',
  created () { },
  data () {
    return {
      bannerList: [],
      accurateUrl,
      controlUrl,
      wasteUrl,
      isHover: 'hover',
      flag1: false,
      flag2: false,
      flag3: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取banner列表
    getList () {
      getBannerList().then(res => {
        const { code, data, message } = res
        if (code === 200) {
          this.bannerList = data || []
          if (this.bannerList.length === 1) {
            this.isHover = 'never'
          }
        } else {
          this.bannerList = []
          message && this.$message.error(message)
        }
      }).catch(() => {
        this.bannerList = []
      })
    },
    clickBanner (bannerName) {
      this.sentLog(100102014, { banner: bannerName })
    }
  }
}
</script>

<style lang="scss" scoped>
.animate__animated.animate__pulse {
  --animate-duration: 0.5s;
}
.land-home-carousel {
  // width: 1920px;
  width: 100%;
  height: 614px;
  margin: auto;
  // background-color: #4499ff;
  ::v-deep .el-carousel__container {
    height: 614px;
    margin: auto;
  }
  img {
    width: 100%;
    object-fit: cover;
  }
}
.land-home-location {
  width: 1200px;
  margin: -51px auto 0px auto !important;
  height: 101px;
  z-index: 2;
  // margin-top: -51px;
  ::v-deep .el-col-8 {
    width: 384px;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  ::v-deep .el-card {
    height: 101px;
    background: #ffffff;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.16);
    // box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
  }
  ::v-deep .el-card:hover {
    img {
      // background-color: #4499ff;
      transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transition: All 3s ease-in-out;
      -webkit-transition: All 3s ease-in-out;
      -moz-transition: All 3s ease-in-out;
      -o-transition: All 3s ease-in-out;
    }
    box-shadow: 0px 7px 9px 0px rgba(0, 0, 0, 0.16);
  }
  ::v-deep .el-card__body {
    padding: 19px;
  }
  .home-location-title {
    // width: 142px;
    // height: 28px;
    font-size: 20px;
    // font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #181f42;
    line-height: 64px;
    // line-height: 28px;
    // margin-bottom: 9px;
  }
  .home-location-text {
    width: 210px;
    // height: 20px;
    font-size: 14px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5c5c65;
    line-height: 20px;
  }
}
</style>
